import { Check } from "lucide-react";

const tiers = [
  {
    title: "Levels 2–5 & XB–XS",
    price: "$140",
    subtitle: "per athlete",
    levels: ["Level 2", "Level 3", "Level 4", "Level 5", "XB", "XS"],
  },
  {
    title: "Levels 6–10 & XG–XSA",
    price: "$160",
    subtitle: "per athlete",
    levels: ["Level 6", "Level 7", "Level 8", "Level 9", "Level 10", "XG", "XP", "XD", "XSA"],
  },
];

const RegistrationPricing = () => {
  return (
    <div className="max-w-3xl mx-auto mb-10">
      <div className="rounded-2xl border border-primary/40 bg-primary/10 px-5 py-3 text-center mb-5">
        <span className="text-[11px] font-bold tracking-[0.25em] text-primary uppercase">Free Team Entries</span>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {tiers.map((t) => (
          <div
            key={t.title}
            className="glass rounded-2xl p-6 border border-white/10 hover:border-primary/40 transition-colors"
          >
            <div className="flex items-baseline justify-between mb-3">
              <h3 className="font-display text-xl text-white tracking-wide">{t.title}</h3>
            </div>
            <div className="flex items-baseline gap-2 mb-4">
              <span className="font-display text-5xl text-gradient leading-none">{t.price}</span>
              <span className="text-white/60 text-sm">{t.subtitle}</span>
            </div>
            <ul className="flex flex-wrap gap-1.5">
              {t.levels.map((l) => (
                <li
                  key={l}
                  className="inline-flex items-center gap-1 rounded-md bg-white/[0.06] text-white/80 text-xs font-medium px-2 py-1 border border-white/10"
                >
                  <Check className="w-3 h-3 text-primary" />
                  {l}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="text-center text-white/50 text-xs mt-4">
        Team entry is free — athlete fees listed above. Prices in USD.
      </p>
    </div>
  );
};

export default RegistrationPricing;